<template>
  <div id="drugordersInbox">
    <MdTitle v-bind:Text="$t('DrugOrdersInbox.DrugOrdersD')" />
      <div class="flex-container">
      <b-row>
        <b-col md="3" lg="3" sm="12">
          <MdDateTime 
            :Label="$t('Shared.datefrom')" 
            :Model="DateFrom"                           
            @input="DateFrom = $event"                            
            :Id="'DrugOrderDateFrom'"
            :Type="'date'"
            :OnPressEnter="searchDrugOrders"
            :isRequired="false"                           
            :isConfirm="false"
            :ReadOnly="false"
            v-bind:isValid="isDateFromValid">
          </MdDateTime> 
        </b-col>
        <b-col md="3" lg="3" sm="12">
          <MdDateTime 
            :Label="$t('Shared.dateTo')"                             
            :Model="DateTo"
            @input="DateTo = $event"                                 
            :Id="'DrugOrderDateTo'"
            :Type="'date'"
            :OnPressEnter="searchDrugOrders" 
            :isRequired="false"
            :isConfirm="false"
            :ReadOnly="false"
            v-bind:isValid="isDateToValid">
        </MdDateTime> 
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdSelect
            v-bind:Label="$t('Shared.Status')"
            v-bind:Options="StatusOptions"
            v-bind:Tag="'DrugOrderStatus'"
            v-bind:FieldDescription="'name'"
            v-bind:FieldCode="'value'"
            v-bind:RequireEvent="true"
            v-bind:Model="StatusModel"  
            v-bind:Multiple="false" 
            :Input="ChangeStatus"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">
          <MdSelect
            v-bind:Label="$t('Shared.Usage')"
            v-bind:Options="UsageOptions"
            v-bind:FieldDescription="'name'"
            v-bind:FieldCode="'value'"
            v-bind:Tag="'DrugOrderUsage'"
            v-bind:RequireEvent="true"
            v-bind:AllowEmpty="false"
            v-bind:Multiple="false"
            v-bind:Model="UsageModel"  
            :Input="ChangeUsage"/>
        </b-col>  
         <b-col lg="3" md="3" sm="12">
          <MdSelect
            v-bind:Label="$tc('Shared.Patient',2)"
            v-bind:Options="PatientsOptions"
            v-bind:FieldDescription="'description'"
            v-bind:FieldCode="'code'"
            v-bind:Name="'DrugOrderInboxPatient'"
            v-bind:ScrollToSelect="true"
            v-bind:Model="PatientsModel"  
            v-bind:Multiple="false" 
            :Input="ChangePatients"
            v-bind:AllowEmpty="true"/>
        </b-col>      
        <b-col lg="3" md="3" sm="12">         
          <MdSelect
						v-bind:Label="$t('Shared.Prescriber')"
						v-bind:FieldDescription="'name'"
						v-bind:FieldCode="'code'"
            v-bind:Tag="'DrugOrderPrescriber'"
						v-bind:Options="PrescriberOptions"
						v-bind:Model="PrescriberModel"											
						v-bind:Multiple="false"
            v-bind:RequireEvent="true"
            v-bind:AllowEmpty="true"
						:Input="ChangePrescriber"/>
        </b-col>
        <b-col lg="3" md="3" sm="12">         
          <MdSelect
            v-bind:Label="$t('Patient.ServiceLocation')"
            v-bind:Options="FacilityOptions"
            v-bind:Model="FacilityModel"
            v-bind:Tag="'DrugOrderFacility'"
            v-bind:FieldDescription="'description'"
            v-bind:FieldCode="'code'"
            v-bind:RequireEvent="true"
            v-bind:AllowEmpty="true"
            v-bind:Multiple="false"             
            :Input="ChangeFacility"/>
        </b-col>
        <b-col v-if="useBranchLocations" lg="3" md="3" sm="12">
          <MdSelect
            v-bind:Label="$t('DrugOrdersInbox.BLocation')"
            v-bind:Options="BranchLocationOptions"
            v-bind:FieldDescription="'description'"
            v-bind:FieldCode="'code'"
            v-bind:RequireEvent="true"
            v-bind:Tag="'DrugOrderBranchLocation'"
            v-bind:AllowEmpty="true"
            v-bind:Multiple="false"
            v-bind:Model="BranchLocationModel"  
            :Input="ChangeBranchLocation"/>
        </b-col>
        <b-col lg="3" md="3" sm="12" :class="classBtn">
          <div class="mt-3 text-right">
          <MdButton
          v-bind:Label="$t('Shared.Search')"
          v-bind:Name="'btnsearchdrugorders'"
          v-bind:ClassProp="'secondary mt-3 mx-1 btn-login'"         
          v-on:click="searchDrugOrders()"/>
          </div>
        </b-col>
      </b-row>
      </div>

      <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
      <div class="row">
        <div class="col-md-12">
          <MdTable
            ref="drugOrdersTable"
            v-bind:fields="tableFields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage"
            v-bind:pageOptions="pageOptions"
            v-bind:isDrugOrders="true"
            v-bind:multiSelect="true"
            v-bind:ShowSelectAll="true"
            v-bind:ShowSelectedCount="true"
            v-bind:ShowSearchCriteria="true"
            v-bind:SelectionKey="'recordId'"
            v-bind:SelectAllFunction="getAllItemsForSelectAll"
            :onSearchCriteria="onSearchCriteriaChanged"
            :viewIconEvent="ViewDrugOrders"
            :otherIconEvent2="ClickInfo"
            v-bind:otherIcon2="'med-help'"
            :otherIconEvent="Print"
            :otherIcon="'printer-fill'"
            :onFiltered="onFiltered"
            :pageChanged="pageChanged"
            :perPageFunction="PerPageFunction"
            v-bind:FieldsDate="FieldsDateArr"
            @selectionChanged="onSelectionChanged"
          >
          </MdTable>
        </div>
      </div>


        <BaseModal v-if="VisibleFormularyStatus"
                ModalId="'ModalIdFormularyStatus'"
                :HideModalFun="CloseFormularyStatus"
                :TitleWindow="$t('DrugOrdersInboxRightBar.FormularyStatus')"
                :width="'20%'"
                :height="'250px'" 
                :UseScrollable="false"
                :buttons="[
                    { text: 'Cancel', variant: 'secondary', action: 'Close' },
                    { text: 'Ok', variant: 'primary', action: handleOkFormularyStatus },                   
                ]"              
                @Close="CloseFormularyStatus"
              >

              <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isFormularyStatusEHRReadOnly">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{$t('Shared.ReadOnlyPermission')}}</span>
                    </div>
                </div>

              <b-row>
                 <b-col lg="12" md="12" sm="12">                       
                        <MdSelect
                            v-bind:Label="$t('Shared.Status')"
                            v-bind:Options="FormularyStatusList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'code'"                          
                            v-bind:Name="'FormularyStatus'"
                            v-bind:Model="ModelFormularyStatus"
                            v-bind:Multiple="false"                                
                            :Input="ChangeDropDownFormularyStatus"
                            :IsDisabled="isFormularyStatusEHRReadOnly || isReadOnly"               
                        /> 
                    </b-col> 
              </b-row>
                
        </BaseModal>


        <MdPatientAllergiesOutCome v-if="activateModalAllergies"
          v-bind:ModalId="'ModalAllergyDrugOrderInbox'"
          v-bind:PatientCode="this.PatientCode"
          v-bind:AdmissionRecordId="AdmissionRecordId"
          v-bind:TitleWindow="'Allergies'"
          v-bind:selectAllByDefault="false"          
          @getCodeConditionOK="onCodeConditionOkModalAllergies($event)"
          @getCancel="onCancelModalAllergies($event)">
        </MdPatientAllergiesOutCome>

        <ModalDrugOrderMedication
          v-if="VisibleModalViewMed"
          :RecordId="RecordId" 
          :AdmissionRecordId="AdmissionRecordId"
          :PatientCode="PatientCode"
          :isControlledSubstance="isControlledSubstance"
          :isUAE="isNRC"
          @OnModalDrugOrderInboxClose="CloseModalMed"
          @Print="Print"
          :TitleWindow="$t('DrugOrdersInboxFill.MedicationInfo')"
          ModalId="'ModalIdModalViewMed'"
        >
        </ModalDrugOrderMedication>


        <MdPatientMedicationsOutCome v-if="activateModalMedications"
          v-bind:ModalId="'ModalMedicationOutComeDrugOrder'"
          v-bind:PatientCode="this.PatientCode"
          v-bind:TitleWindow="'Medication History'"
          @getCodeConditionOK="onCodeConditionOkModalMedHistory($event)"
          @getCancel="onCancelModalMedHistory($event)">
        </MdPatientMedicationsOutCome>

        <DxPopup 
            :visible="isReportPatientFaceSheetVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="reportTitle"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
          >
            <ReportViewer
            ref="PatientFaceSheetRep"
            :ReportName="'PatientFaceSheet'"
            :ReportTitle="reportTitle"
            :IsAnAPIReport="true"
            />
          </DxPopup>

          <DxPopup
            :visible="isReportPatientMedicationVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="$t('PatientMedications.ReportMedications')"
            @hidden="onHiddenMedicationReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"            
            @showing="onShowing"
            :wrapper-attr="popupAttributes"
          >
            <ReportViewer
              ref="patientMedications"
              :ReportName="'PatientMedications'"
              :ReportTitle="$t('PatientMedications.ReportMedications')"
              :IsAnAPIReport="true"
            />
        </DxPopup>

        <DrugOrderNotesDlg
          :visible="addNoteVisible"
          :item="addNoteItem"
          @close="closeHandler"
          @ok="okHandler"
          :Origin="Origin"
          @ret:comments="setStatusUnableToFillHandler"
          :editable="pharmacyNoteEditable"
        >
        </DrugOrderNotesDlg>

        <MDTextEditorDialog
          :visible="textEditorVisible"
          v-model="textEditorValue"
          @close="closeTextEditorHandler"
          @ok="okTextEditorHandler"
          :handlerOk="undoFillOrdersAsync"
          :required="true"
        >
        </MDTextEditorDialog>

        <MedicationLabelsRep v-if="isMedicationLabelsRepVisible"
          :closeWindow="closeParamRepWindow" 
          :codeList="getRecordId()"
        />

      <BaseModal
          v-if="SignotecVisible" 
          ModalId="SignotecModalId"
          :TitleWindow="`Sign`"
          :width="'30%'"
          :height="'auto'"
          :HideModalFun="SignotecOnCancel"
          @Close="SignotecOnCancel"
          :buttons="[
              { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
              { text: $t('Shared.TitleOK'), variant: 'primary', action: SignotecOnOK },
          ]">

          <MdSignotec 
            ref="mdSignotec"
            @OnSignotecSubmitImage="SignotecOnSubmitImage" 
            @OnSignotecError="SignotecOnError" 
            @OnSignotecConfirm="SignotecOnConfirm"
            @OnSignotecCancel="SignotecOnCancel" />

      </BaseModal>

  </div>
</template>

<script>
import Utils from '@/common/utils'
import { EventBus } from '@/event-bus.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import EnumService from "@/services/enum.service"
import DrugOrdersInboxService from '@/services/drugordersinbox.service'
import Permission from '@/common/Permission'
import MedicationService from '@/services/medication.service'
import FacilitiesService from '@/services/facilities.service'
import ProviderService from '@/services/provider.service'
import EmployeeService from '@/services/employee.service'
import PatientsService from '@/services/patient.service'
import ModalDrugOrderMedication from '@/components/pages/drugordersinbox/modalDrugOrderViewMedication';
import DrugOrderNotesDlg from './DrugOrderNotesDlg'
import { DxPopup } from 'devextreme-vue/popup';
import { drugOrdersStore } from '@/components/pages/drugordersinbox/drugOrdersStore';
import GlobalService from '@/services/global.service'
import LocalStorage from '@/services/storage.service';
//import LetterTemplatesService from '@/services/lettertemplates.service.js';
//import ApiService from '@/services/api.service';
//import qz from "qz-tray";

export default {
  name: 'DrugOrdersInbox',
  mixins: [ShowMessage, Utils, Permission],
  components: {ModalDrugOrderMedication, DrugOrderNotesDlg,DxPopup},
  props: {
    employee: Boolean
  },
  data(){
    return{
        Origin:"PharmacyNotes",
        VisibleFormularyStatus:false,
        isMedicationLabelsRepVisible: false,
        isFormularyStatusEHRReadOnly:false,
        FormularyStatusList:[
          {code:"Formulary",name:this.$t('DrugOrdersInbox.Formulary')},
          {code:"Non-Formulary",name:this.$t('DrugOrdersInbox.NonFormulary') },
          {code:"Patient Own",name:this.$t('DrugOrdersInbox.PatientOwn') },
          {code:"To be Changeable",name:this.$t('DrugOrdersInbox.TobeChangeable')}
        ],  
        ModelFormularyStatus: {code:"Formulary",name:this.$t('DrugOrdersInbox.Formulary')},
        activateModalMedications:false,   
        isNRC:this.$store.state.companies.isNRC,
        RecordId:"",
        PatientCode:"", 
        isControlledSubstance:"",
        AdmissionRecordId:"", 
        VisibleModalViewMed:false,
        isReportPatientFaceSheetVisible: false,
        isReportPatientMedicationVisible: false,
        reportTitle: this.$t('MdPatientInfoBox.PatientFaceSheet'),
        modelSearch:"",
        PrescriberModel: null,
        PatientsModel:null,       
        FacilityModel: null,
        StatusModel: {value:'',name: this.$t('Shared.All')},
        UsageModel: {value:'',name: this.$t('Shared.All')},
        activateModalAllergies:false,

        PrescriberOptions: [],
        FacilityOptions: [],
        StatusOptions: EnumService.DrugOrdersInboxStatus,
        UsageOptions: EnumService.DrugOrdersInboxUsage,
        BranchLocationOptions: [],

        DateFrom: "",
        DateTo: "",
        SelectedRecords:0,
        
        ReporterModel: null,
        WorkflowModel: null,
        ProgramModel :  null,
        IncidentModel: null,
        SeverityModel: null,
        NotesModel   : { description: this.$t('Shared.All')},
        BranchLocationModel: null,
        
        NotesStatusModel : { value: 'all', name: this.$t('Shared.All') },
        PatientsOptions: [],
        ReporterOptions: [],
        WorkflowOptions: [],
        ProgramOptions : [],
        IncidentOptions: [],
        SeverityOptions: [],
        NotesOptions   : [],
        RightMenuList: JSON.parse(JSON.stringify(EnumService.DrugOrdersInboxItems)), //EnumService.DrugOrdersInboxItems,
        NotesStatusOptions : EnumService.IncidentWorkflowNotesStatusOptions,

        parameter:{
          SearchCriteria:'',
          PageNumber : null,
          PageSize:null,
          Status: false,
        },
        paramPatient:{
          SearchCriteria:'',
          PageNumber : null,
          PageSize:null,
        },
        isDateFromValid: true,
        isDateToValid: true,
        OptionsRightMenu:{
            visible:false,
            btnvisible:false,
            ItemsList:[],
            favButtonAtion: false
        },
        fields: [         
          { key: 'recordId', sortable: true, label: this.$t('Orders.UID'), class: 'hidden' },
          { key: 'admissionRecordId', sortable: true, label: this.$t('Orders.UID'), class: 'hidden' },
          { key: 'issuedDateDrugOrder', sortable: true, label: this.$t('Medication.StartDate'), class: 'text-rigth' },          
          { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
          { key: 'patientCode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' },
          { key: 'branchLocation', sortable: true, label: this.$t('DrugOrdersInbox.BLocation'), class: 'text-rigth' },
          { key: 'usage', sortable: true, label: this.$t('Shared.Usage'), class: 'text-rigth' },
          { key: 'rxStatus', sortable: true, label: this.$t('Medication.RxStatus'), class: 'text-rigth' },
          { key: 'mode', sortable: true, label: this.$t('Shared.Mode'), class: 'text-rigth hidden' },
          { key: 'drugName', sortable: true, label: this.$t('drug.Drugname'), class: 'text-rigth' },
          { key: 'activeIngredients', sortable: true, label: this.$t('Shared.activeIngredients'), class: 'text-rigth' },
          { key: 'drugCode', sortable: true, label: this.$t('drug.DrugCode'), class: 'text-rigth' },
          { key: 'quantity', sortable: true, label: this.$t('Shared.quantity'), class: 'text-rigth', 
            formatter: (value) => {
             const num = parseFloat(value);
              if (isNaN(num)) return '0.00';
              return new Intl.NumberFormat('en-US', {
                style: 'decimal'               
              }).format(num);
            }          
          },
          { key: 'form', sortable: true, label: this.$t('Medication.Form'), class: 'text-rigth' },         
          { key: 'sig', sortable: true, label: this.$t('Medication.Sig'), class: 'text-rigth' },
          { key: 'prescriber', sortable: true, label: this.$t('Shared.Prescriber'), class: 'text-rigth' },
         // { key: 'internalStatus', sortable: true, label: this.$t('Shared.Status'), class: 'text-rigth' },
         // { key: 'drugType', sortable: true, label: this.$t('Shared.DrugType'), class: 'text-rigth' },
          { key: 'chargeableTranslated', sortable: true, label: this.$t('Medication.Chargeable'), class: 'text-rigth' },
          { key: 'formularyStatus', sortable: true, label: this.$t('DrugOrdersInboxRightBar.FormularyStatus'), class: 'text-rigth' },
          { key: 'isPatientOwnMedicationTranslated', sortable: true, label: this.$t('Medication.PatientOwned'), class: 'text-rigth'},
          { key: 'program', sortable: true, label: this.$tc('Shared.Program',1), class: 'text-rigth' },
          { key: 'building', sortable: true, label: this.$t('Shared.Building'), class: 'text-rigth' },         
          { key: 'roomName', sortable: true, label: this.$tc('Shared.Room',1), class: 'text-rigth' },
        ],
        FieldsDateArr:['issuedDate', 'issuedDateDrugOrder'],
        items: [],
        totalRows: 0,
        isReadOnly: false,
        ShowMessageIsEmpty:false,
        currentPage: 1,
        perPage: 10,
        SelectedCounter:[],
        pageOptions: [5, 10, 15,20,30,40,50],
        selected: [],
        ButtonLabel: null,
        params: {
          SearchCriteria: '',
          PageNumber: 1,
          PageSize: 10,
          DateFrom: this.DateFrom,
          DateTo: this.DateTo,
          Status: '',
          Prescriber: '',
          Facility: '',
          PatientCode: '',
          UsageIsInpatient: null,
          BranchLocation: '',
        },
        btnVoidIncidentRO: true,
        btnVoidIncidentLabel: this.$t('MdNote.Void').toUpperCase(),
        btnForceCompletionRO: true,
        SeeIncidentWFAdmin: false,
        RecID: '',
        indexSelected: 0,
        selectedItems: [],
        useBranchLocations: true,
        classBtn: 'ml-auto',
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        addNoteVisible: false,
        addNoteItem: {},
        pharmacyNoteEditable: true,
        textEditorVisible: false,
        textEditorValue: '',
        itemsSelected: [],
        printData: null,
        noteUndoFill: '',

        SignotecEnabled: false,
        SignotecVisible: false,
        SignotecSignatureFile: null
    }
  },

  computed: {
  tableFields() { 
    if(this.isNRC) {
       return this.fields.filter(item => item.key !== 'isPatientOwnMedicationTranslated');
    }
    return this.fields;
  },

  drugOrdersStore() {
      return drugOrdersStore;
  },  
},

watch: {
    'drugOrdersStore.updatedAt'() {
      if (!drugOrdersStore.executeAction) return;      
      this.HandlerClick(drugOrdersStore.executeAction);
    },   
  },

  methods:{

    CloseFormularyStatus(){ 
       setTimeout(() => {
         this.VisibleFormularyStatus = false;
        },0);

        this.ModelFormularyStatus = !this.isFormularyStatusEHRReadOnly ? {code:"Formulary",name:this.$t('DrugOrdersInbox.Formulary')} :{code:"",name:""};
    },

    handleOkFormularyStatus(){
      if(!this.isFormularyStatusEHRReadOnly){
        this.updateFormularyStatus();
      }else{
        this.CloseFormularyStatus();
      }
      
    },

    updateFormularyStatus() {
        let params = {
          "RecordIds": [],
          "Status": this.ModelFormularyStatus.code
        }
        this.selected = this.getSelection();
        this.selected.forEach(el => {
          params.RecordIds.push(el.recordId.trim())
        });

        DrugOrdersInboxService.UpdateFormularyStatus(params)
          .then((response) => {
            if(response.status == '200'){                       
              setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              }), 50);
              this.CloseFormularyStatus();
              this.getDrugOrdersInbox(); 
            }               
          })
          .catch((error) => {
             this.CloseFormularyStatus();
            this.showResponseErrorMessage(error);
          });
        },

    closeParamRepWindow() {
     this.isMedicationLabelsRepVisible = false
    }, 

    ChangeDropDownFormularyStatus(item){
      this.ModelFormularyStatus = item ? item : {code:"",name:""};
    },

    HandlerClick(Action){   
      switch (Action) {
        case "SetToPending":
          this.SetStatusHandler("PENDING");
          break;
        case "SetToOrdered": 
          this.SetStatusHandler("ORDERED");       
          break;
        case "FillOrder":
          this.ExecuteView("DrugOrdersInboxFill");
          break;   
        case "SetToValid":
          this.ExecuteView("DrugOrdersInboxValidation");
          break;  
        case "AddNotes":
          this.AddingNotes();
          break;
        case "ViewMedHistory":
          this.activateModalMedications = true;
          break; 
        case "DrugInfo": 
          this.OpenDrugInfo(this.getSelection());         
          break;          
        case "PatientInfo": 
          this.DoReport();      
          break;
        case "ReturnedItems": 
          this.ExecuteView("DrugOrdersReturnedItems");
          break;
        case "SetToChargeable": 
          this.updateChargeable("CHARGEABLE"); 
          break;
        case "SetToUnableToFill": 
          this.SetStatusHandler("UNABLETOFILL");  
          break;      
        case "UndoFillOrders": 
          this.undoFillOrders();
          break;
        case "UndoSetToChargeable": 
          this.updateChargeable("UNDOCHARGEABLE");
          break;
        case "UndoValidated": 
          this.UndoValidate();
          break;
        case "PatientAllergy": 
          this.activateModalAllergies = true;
          break;
        case "FormularyStatus": 
          this.VisibleFormularyStatus = true;
          break;  
        case "PrintMedLabel": 
          this.isMedicationLabelsRepVisible = true;
          //this.getMedLabelPdf()
          break;           
        default:          
      }
    },

    popupAttributes(){

    },

    onShowing(e) {
      let contentElement = e.component.content();
      let titleElement = e.component._$title[0];
      contentElement.style.padding = '0px';
      titleElement.style.padding = '0px 20px';
    },

    UndoValidate(){
      this.$bvModal
        .msgBoxConfirm(this.$t('DrugOrdersInbox.UndoValidateMsg', {'label': this.getSelection().length}), {
          title: this.$t('DrugOrdersInboxRightBar.Undovalidated'),
          okTitle: this.$t('DrugOrdersInbox.TitleUndoValidate'),
          cancelTitle: this.$t('Shared.BtnCancel'),
          footerClass: "p-2",
          titleClass: "modal-title modal-type-warning",
        })
        .then((value) => {
          if (value) {
            this.SetStatusUndoValidate();           
          }
        });
    },


  DoReport() {
		let reportParams = [];
    reportParams.push({ paramName: 'PatientCodeList', paramValue: this.PatientCode});
		reportParams.push({ paramName: 'ActivePatient', paramValue: ''});
    reportParams.push({ paramName: 'ActiveAdmission', paramValue: ''});        
    this.isReportPatientFaceSheetVisible = true;
    this.$refs.PatientFaceSheetRep.buildDocument(reportParams);
	},

    IsSameDrugCode(arr){   
      return arr.every(item => item.drugCode === arr[0].drugCode);
    },

    onHiddenReport() {
      this.isReportPatientFaceSheetVisible = false;      
    },

    onHiddenMedicationReport() {
      this.isReportPatientMedicationVisible = false;
    },
    

    OpenDrugInfo(arr){
     if(this.IsSameDrugCode(arr)){
        this.getUrlDrugInfo(arr[0].drugCode);
     }
    },

    SetStatusHandler(status) {
      const selected = this.getSelection();
      if (status == 'UNABLETOFILL') {   
        this.pharmacyNoteEditable = false;
        this.addNoteItem = selected[0];
        this.addNoteVisible = true;
        //this.Origin = "UnableToFill";

      } else {
        let params = {
          "recordIds": [],
          "status": "",
          "pharmacistNotes": ""
        }
        params.status = status;        
        selected.forEach(el => {
          params.recordIds.push(el.recordId.trim());
        });
        this.setStatus(params);
      }
    },

    SetStatusUndoValidate() {
      const selected = this.getSelection();
        let params = {
          "recordIds": []
        }
        selected.forEach(el => {
          params.recordIds.push(el.recordId.trim());
        });
        this.setStatusUndoValidate(params);
    },

    AddingNotes() {
      const selected = this.getSelection();
      if (selected.length === 1) {
        this.pharmacyNoteEditable = true;
        this.addNoteItem = selected[0];
        this.addNoteVisible = true;
      } else {
        this.showMessage(this.$tc('Msg.Warning'),this.$t('DrugOrdersInbox.InvalidSelection'),"warning");
      }
    },

    returnedItems(){

    },

    ExecuteAction(actionName){
       if (actionName === 'AddNotes') {
        this.addingNotes();
      } else if (actionName === 'ReturnedItems') {
        this.returnedItems();
      } else if (actionName === 'UndoFillOrders') {
        this.undoFillOrders();
      }  
    },

    ExecuteView(routeName){
      let recordIds = []; 
      this.selected  = [];     
      this.selected = this.getSelection();      
      this.selected.forEach(el => {
        recordIds.push(el.recordId.trim())
      });
      
      if(this.selected.length > 0){
        sessionStorage.setItem('DrugOrdersValidationRecordsId', JSON.stringify(recordIds));
         this.$router.push({ name: routeName });
      }
    },

    

    setStatus(data) {
      this.$emit('load', true);       
      DrugOrdersInboxService.UpdateStatus(data)
        .then((response) => {
          if(response.status == '200'){  
            if(data.recordIds.length === response.data.affectedRows){
                setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              }), 50);
            }else{
                 setTimeout(() => 
              this.$bvToast.toast(response.data.affectedRows +" out of "+data.recordIds.length+" items sent were affected", {
              title:this.$tc('Msg.Warning', 1),
              autoHideDelay: 5000,
              variant: "warning"
            }), 50);
            }                     
         
            
            this.getDrugOrdersInbox() 
          }  
            this.$emit('load', false);                  
        })
        .catch((error) => {
          this.$emit('load', false);
          this.showResponseErrorMessage(error);
        });
    },

    
    setStatusUndoValidate(data) {
      this.$emit('load', true);       
      DrugOrdersInboxService.UpdateStatusUndoValidate(data)
        .then((response) => {
          if(response.status == '200'){  
            if(data.recordIds.length === response.data.affectedRows){
                setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              }), 50);
            }else{
                 setTimeout(() => 
              this.$bvToast.toast(response.data.affectedRows +" out of "+data.recordIds.length+" items sent were affected", {
              title:this.$tc('Msg.Warning', 1),
              autoHideDelay: 5000,
              variant: "warning"
            }), 50);
            }                     
         
            
            this.getDrugOrdersInbox() 
          }  
            this.$emit('load', false);                  
        })
        .catch((error) => {
          this.$emit('load', false);
          this.showResponseErrorMessage(error);
        });
    },






    ChangePatients(item){
      this.params.PatientCode = '';   
      if(item != null)  {
        this.params.PatientCode = item.code;
        this.PatientsModel = item;
      } else {
        this.PatientsModel = null;
      }
      this.searchDrugOrders();
    },

    CloseModalMed(){
      this.VisibleModalViewMed = false;
    },

 
    async getProvider(){
      await ProviderService.get(this.$store.state.providerCode)
            .then((response) => {      
               if (response.status == '200' && response.data) { 
                  this.useBranchLocations = response.data.useBranchLocations;
                  this.classBtn = this.useBranchLocations ? 'ml-auto text-right' : 'ml-auto';
               }  
         })
         .catch(error => { 
          if (!error.response) {                      
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }                  
         });
             
    },

    async getBranchLocationsCurrentUser(){
      await EmployeeService.getBranchLocationsCurrentUser()
            .then((response) => {      
               if (response.status == '200' && response.data) { 
                  this.BranchLocationOptions = response.data
               }  
         })
         .catch(error => { 
          if (!error.response) {                      
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }                  
         });             
    },

    Print(row) {
      let reportParams = [];     
      reportParams.push({ paramName: 'patientCode', paramValue: row.patientCode?.trim() ?? null })
      reportParams.push({ paramName: 'recNo', paramValue: row.recordId?.trim() ?? null })
      reportParams.push({ paramName: 'isControlledSubstance', paramValue: row.drugType ?? null })
      reportParams.push({ paramName: 'isUAE', paramValue:this.isNRC })

      if (!row.recordId) {
        reportParams.push({ paramName: 'dateFrom', paramValue: row.dateFrom ?? null })
        reportParams.push({ paramName: 'dateTo', paramValue: row.dateTo ?? null })
        reportParams.push({ paramName: 'status', paramValue: row.status.value })
      }

      this.isReportPatientMedicationVisible = true
      this.$refs.patientMedications.buildDocument(reportParams)
    },

    ViewDrugOrders(item) {
      this.RecordId = item.recordId;
      this.AdmissionRecordId = item.admissionRecordId?.trim();
      //this.PatientCode = item.patientCode ? item.patientCode.trim():null;   
      this.PatientCode = item.patientCode?.trim();
      this.isControlledSubstance = item.drugType ? item.drugType.trim():null;
      this.VisibleModalViewMed = true;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },  

    onCancelModalAllergies(){
      this.activateModalAllergies = false;
    },

    onCancelModalMedHistory(){
      this.activateModalMedications = false;
    },

    onCodeConditionOkModalAllergies(){
      this.activateModalAllergies = false;
    },

    onCodeConditionOkModalMedHistory(){
      this.activateModalMedications = false;
    },

    getSelection() {
      return this.selectedItems;
    },

    onSelectionChanged(items) {
      this.selectedItems = items;
      this.SelectedRecords = items.length;
      const patientCodeList = [...new Set(items.map(x => x.patientCode.trim()))];
      EventBus.$emit('loadMenu', patientCodeList.join(','));
      this.PatientCode = (items.length > 0 && this.IsSamePatient(items)) ? items[0].patientCode.trim() : null;
      this.AdmissionRecordId = items.length > 0 ? items[items.length - 1].admissionRecordId?.trim() : null;
      this.EnabledAllItems(items);
      this.itemsSelected = items.filter(item =>
        item.internalStatus === 'FILLED' || item.internalStatus === 'PARTIALLYFILLED'
      );
    },

    async getAllItemsForSelectAll(searchCriteria) {
      const params = {
        DateFrom: this.params.DateFrom,
        DateTo: this.params.DateTo,
        Status: this.params.Status,
        Prescriber: this.params.Prescriber,
        Facility: this.params.Facility,
        PatientCode: this.params.PatientCode,
        UsageIsInpatient: this.params.UsageIsInpatient,
        BranchLocation: this.params.BranchLocation,
        ProgramsRestriction: this.params.ProgramsRestriction,
        SearchCriteria: searchCriteria !== undefined ? searchCriteria : this.modelSearch
      };
      const response = await DrugOrdersInboxService.getAll(params);
      if (response.data) return response.data;
      return [];
    },

    searchDrugOrders() {
      this.currentPage = 1;
      this.getDrugOrdersInbox();
    },

    onSearchCriteriaChanged(criteria) {
      this.modelSearch = criteria;
      this.searchDrugOrders();
    },

    async pageChanged(page) {
      this.currentPage = page;
      this.getDrugOrdersInbox();
    },

    PerPageFunction(perpage) {
      this.perPage = perpage;
      this.currentPage = 1;
      this.getDrugOrdersInbox();
    },

     getPatients() {
      PatientsService.getPatientLookup()
        .then((response) => { 
          if(response.data && response.data.length > 0){   
            this.PatientsOptions = response.data;

            this.PatientsOptions.forEach(element => {
              element.description = element.description?.trim()+" - "+element.code;
            });
          }
        })
        .catch(error => {         
          this.showResponseErrorMessage(error); 
        });  
    },

     async getDateTime() { 
         await GlobalService.getDateTime()
            .then((response) => {      
               if (response.data) {   
                this.DateFrom =  response.data;
                this.DateTo = response.data;
               }  
         })
         .catch(error => {          
            this.showResponseErrorMessage(error);
         }); 
      },


    async getDrugOrdersInbox() {
      if (!this.validateForm()) return;

      this.params.BranchLocation = this.params.BranchLocation === "<ALL>" ? null : this.params.BranchLocation;
      this.params.DateFrom = this.DateFrom;
      this.params.DateTo = this.DateTo;
      this.params.ProgramsRestriction = this.$store.state.restrictions.programs.join(',');
      this.params.SearchCriteria = this.modelSearch;
      this.params.PageNumber = this.currentPage;
      this.params.PageSize = this.perPage;
      await DrugOrdersInboxService.getAll(this.params)
        .then((response) => {
        if(response.data){
          const data = response.data;
          data.forEach(function(element) {
            element.counted = false;
            element.selected = false;
            if (element.issuedDate)
              element.issuedDateDrugOrder = `${Utils.formatterDateToString(element.issuedDate)}`;
          });
          this.items = data;
          const headerString = response.headers['x-pagination'];
          this.totalRows = headerString ? JSON.parse(headerString).TotalCount : data.length;
          this.ShowMessageIsEmpty = this.totalRows === 0;
          this.ResetItems(this.RightMenuList);
          EventBus.$emit('cleanPatientInfo');
        }
        })
        .catch((error) => {
          this.showResponseErrorMessage(error);
        });
    },

    async getPrescribers() {
      await MedicationService.getPrescribers()
        .then((response) => { 
        if(response.data){
          this.PrescriberOptions = response.data;        
        }             
        })
        .catch((error) => {         
          this.showResponseErrorMessage(error);
        });
    },

    async getFacilities() {
      /*let params = {}
      params.PageNumber = 1;
      params.PageSize = 100;*/
      await FacilitiesService.getFacilitiesLookup()
        .then((response) => { 
        if(response.data){
          this.FacilityOptions = response.data;         
        }             
        })
        .catch((error) => {         
          this.showResponseErrorMessage(error);
        });
    },
    
    DateFromChange(value) {
      this.params.DateFrom = value
      //sessionStorage.setItem('DrugOrdersValidationDateFrom', value);
    },

    DateToChange(value) {
      this.params.DateTo = value
     // sessionStorage.setItem('DrugOrdersValidationDateTo', value);
    },

    ChangeUsage(item) {
      if(item != null)  {
        this.UsageModel = item;
        this.params.UsageIsInpatient = item ? item.value : null;
       // sessionStorage.setItem('DrugOrdersValidationUsage', JSON.stringify(item));
      } else {
        this.UsageModel = null;
      }
      this.searchDrugOrders();
    },
    ChangeBranchLocation(item) {
      this.params.BranchLocation = ''   
      if(item != null)  {
        this.BranchLocationModel = item;
        this.params.BranchLocation = item.code
      } else {
        this.BranchLocationModel = '';
      }
      this.searchDrugOrders();
    },

    ChangeFacility(item) {
      this.params.Facility = ''   
      if(item != null)  {
        this.params.Facility = item.code
        this.FacilityModel = item;
      } else {
        this.FacilityModel = null;
      }
      this.searchDrugOrders();
    },

    ChangePrescriber(item) { 
      this.params.Prescriber = ''  
      if(item != null)  {
        this.PrescriberModel = item;
        this.params.Prescriber = item.code;
        // sessionStorage.setItem('DrugOrdersValidationPrescriber', JSON.stringify(item));
      } else {
        this.PrescriberModel = null;
        //sessionStorage.removeItem('DrugOrdersValidationPrescriber');
      }
      this.searchDrugOrders();
    },

    ChangeStatus(item) {
      this.params.Status = ''
      if (item != null) {
        this.StatusModel = item;
        this.params.Status = item.value
       // sessionStorage.setItem('DrugOrdersValidationStatus', JSON.stringify(item));
      }
      this.searchDrugOrders();
    },

    setStatusUnableToFillHandler(pharmacistNotes) {
      let params = {
          "recordIds": [],
          "status": "",
          "pharmacistNotes": ""
        }
        params.status = 'UNABLETOFILL'
        this.selected = this.getSelection();
        this.selected.forEach(el => {
          params.recordIds.push(el.recordId.trim())
        });

        params.pharmacistNotes = pharmacistNotes
        this.setStatus(params)
    },

    okHandler() { 
        this.pharmacyNoteEditable = true;    
        this.addNoteVisible = false;
        this.addNoteItem = null;       
    },

    closeHandler() {
      this.pharmacyNoteEditable = true; 
        this.addNoteVisible = false;
        this.addNoteItem = null;
    },

    okTextEditorHandler() {
        this.textEditorVisible = false;
        this.textEditorValue = '';
    },

    closeTextEditorHandler() {
        this.textEditorVisible = false;
        this.textEditorValue = '';
    },

    

    async ExecuteAllCalls(){
      this.getPatients();
      this.getPrescribers()
      this.getFacilities()
     await this.getProvider();
     if(this.useBranchLocations){
      this.getBranchLocationsCurrentUser()  
     } 
      await this.getDateTime();      
      this.getDrugOrdersInbox()
    },

      ClickInfo(item){
            if(item.drugCode !== null && item.drugCode !== ""){
                this.getUrlDrugInfo(item.drugCode);
            }else{
                this.showMessage(this.$tc('Msg.Warning',1),this.$t('Medication.NoDrugCode'),"warning");
            } 
        },

    async getUrlDrugInfo(drugCode){        
      await MedicationService.getUrlDrugInfo(drugCode)
            .then((response) => {      
               if (response.status == '200' && response.data) {
                    window.open(response.data.url, '_blank');      
               }               
         })
         .catch(error => {            
            this.showResponseErrorMessage(error);                
         });    
    },

     ResetItems(arr){
         arr.forEach(element => {
           element.ReadOnly = true;
         });
         this.UpdateMenu(arr); 
     },

     IsSamePatient(arr){   
      return arr.every(item => item.patientCode === arr[0].patientCode);
     },


    getRecordId() {
      let recordIdList = [] //this.itemsSelected[0] ? this.itemsSelected[0].recordId : null

      this.itemsSelected.forEach(item => {
        recordIdList.push(item.recordId.trim())
      }); 

      return recordIdList
    },

    setItemSelected(item) {
      if (item.internalStatus == "FILLED" || item.internalStatus == "PARTIALLYFILLED") {      
        let itemselected = this.itemsSelected.findIndex((element) => element.recordId == item.recordId)

        if (itemselected != -1 && !item.selected) {
          this.itemsSelected.splice(itemselected, 1)
        } else if (itemselected == -1 && item.selected) {
          this.itemsSelected.push(item)
        } 
      } 
    },

    PatientOwnMedication(arr){
      let count  = 0;
        arr.forEach(element => {
          if(element.isPatientOwnMedication){
            count++;
          }
        })

        return count > 0;
    },

    ValidateUsage(arr,usage){
       let count  = 0;
        arr.forEach(element => {
          if(element.usage?.toUpperCase() === usage){
            count++;
          }
        })
        return count > 0;
    },

    ValidateState(arr,state){      
       let count  = 0;
        arr.forEach(element => {
          if(element.internalStatus?.toUpperCase() === state){
            count++;
          }
        })
        return count > 0;
    },
   
    ValidateFillOrderBtn(arr){
       let count  = 0;
         arr.forEach(element => {
          if( (element.internalStatus?.toUpperCase() === 'PENDING' || element.internalStatus?.toUpperCase() === 'PARTIALLYFILLED') 
            && ((!this.isNRC && element.isPatientOwnMedication) || (this.isNRC && element.usage?.toUpperCase() === 'HOME' ) ) ){
              count++;
          }
        })
         return count > 0;
    },

    ValidateSetUnableToFillBtn(arr){
        let count  = 0;
        //&& element.rxStatus?.toUpperCase() === 'ACTIVE'
         arr.forEach(element => {
          if(!element.isPatientOwnMedication  && 
            (element.internalStatus?.toUpperCase() === 'PENDING' || element.internalStatus?.toUpperCase() === 'ORDERED') ){
              count++;
            }
         })
         return count > 0;
    },

    ValidateSetToValidBtn(arr){
        let count  = 0;
         arr.forEach(element => {
            if(  ( (this.isNRC) || (element.isPatientOwnMedication) )  && 
            (element.internalStatus?.toUpperCase() === 'PENDING' || element.internalStatus?.toUpperCase() === 'AUTO VALIDATED') 
            && element.usage?.toUpperCase() === 'INTERNAL'){
              count++;
            }
         })
        return count > 0;
    },

    ValidateUndoValid(arr){
      let count  = 0;
       arr.forEach(element => {
        if( ( (this.isNRC) || (element.isPatientOwnMedication)  )  &&  element.internalStatus?.toUpperCase() === 'VALIDATED'){
          count++;
        }
       })
       return count > 0;
    },
 
    ValidateUndoSetToChargeableBtn(arr){
        let count  = 0;
       arr.forEach(element => {
        if(element.chargeable && element.internalStatus?.toUpperCase() !== "VOIDED"){
          count++;
        }
       })
       return count > 0;
    },

    ValidateReturnItemsBtn(arr){
       let count  = 0;
       arr.forEach(element => {
          if(element.internalStatus?.toUpperCase() === 'RECEIVED' || element.internalStatus?.toUpperCase() === 'FILLED' 
          || element.internalStatus?.toUpperCase() === 'MARSCREATED' || element.internalStatus?.toUpperCase() === 'PARTIALLYGIVEN' ){
             count++;
          }
       })
       return count > 0;
    },

    ValidateChargeable(arr){
       let count  = 0;
        arr.forEach(element => {
          if(element.chargeable){
            count++;
          }
        })
        return count === arr.length;
    },

    ValidateNoChargeable(arr){
       let count  = 0;
        arr.forEach(element => {
          if(!element.chargeable){
            count++;
          }
        })
        return count === arr.length;
    },

    ValidateNotVoided(arr){
       let count  = 0;
        arr.forEach(element => {
          if(element.internalStatus?.toUpperCase() !== "VOIDED"){
            count++;
          }
        })
        return count > 0;
    },

    ValidatePrintMedLabelBtn(arr){
       let count  = 0;
        arr.forEach(element => {
          if(element.internalStatus?.toUpperCase() === "FILLED" || element.internalStatus?.toUpperCase() === "PARTIALLYFILLED"){
            count++;
          }
        })
        return count > 0;
    },

     ValidateSetToPending(arr){
        let count  = 0;
        arr.forEach(element => {
          if(element.internalStatus?.toUpperCase() === "ORDERED" || element.internalStatus?.toUpperCase() === "UNABLETOFILL"){
            count++;
          }
        })
        return count > 0;
     },



    ValidateRxStatus(arr, status) {
      let count  = 0;
        arr.forEach(element => {
          if(element.rxStatus?.toUpperCase() === status.toUpperCase()){
            count++;
          }
        })
        return count === arr.length;
    },    

     EnabledAllItems(arritemsSelected){
       let arr = this.RightMenuList;      
      arr.forEach(element => {

        if(element.value === 'Settopending'){
          if(this.items.length > 0 && this.SelectedRecords > 0 &&  this.ValidateSetToPending(arritemsSelected)){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }
        }

        if(element.value === 'Addingnotes'){
          if(this.items.length > 0 && this.SelectedRecords === 1){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }

        if(element.value === 'FormularyStatus'){
          if(this.items.length > 0 && this.SelectedRecords > 0){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }

        if(element.value === 'Settoordered'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.ValidateState(arritemsSelected,"PENDING")){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        } 

        if(element.value === 'Settounabletofill'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.ValidateSetUnableToFillBtn(arritemsSelected)){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }           
        }

        if(element.value === 'Fillorder'){
            if(this.items.length > 0 && this.SelectedRecords >= 1 && this.ValidateFillOrderBtn(arritemsSelected)){
              element.ReadOnly = false;
            }else{
               element.ReadOnly = true;
            }           
        }

        if(element.value === 'Undofillorders'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.ValidatePrintMedLabelBtn(arritemsSelected)){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }

        if(element.value === 'Settovalid'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.ValidateSetToValidBtn(arritemsSelected)){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }

        if(element.value === 'Undovalidated'){
          if(this.items.length > 0 && this.SelectedRecords > 0  && this.ValidateUndoValid(arritemsSelected)  ){
             element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }         
        }

        if(element.value === 'SetToChargeable'){
          if(this.items.length > 0 && this.SelectedRecords === 1 && 
          this.ValidateNoChargeable(arritemsSelected) && this.ValidateNotVoided(arritemsSelected) ){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }

        if(element.value === 'UndoSetToChargeable'){
          if(this.items.length > 0 && this.SelectedRecords === 1 && this.ValidateUndoSetToChargeableBtn(arritemsSelected)
          ){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }

        if(element.value === 'Returneditems'){
          if(this.items.length > 0 && this.SelectedRecords > 0  && this.ValidateReturnItemsBtn(arritemsSelected)){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }

        if(element.value === 'Printmedlabels'){
          if(this.items.length > 0 && this.ValidatePrintMedLabelBtn(arritemsSelected) ){
            element.ReadOnly = false;
          }else{
             element.ReadOnly = true;
          }          
        }

        if(element.value === 'Patientinformation'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.IsSamePatient(arritemsSelected)){
             element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }         
        }

        if(element.value === 'Prescription'){
          if(this.items.length > 0 && this.SelectedRecords === 1){
            element.ReadOnly = false;
          }else{
           element.ReadOnly = true;
          }          
        }

        if(element.value === 'Printmedicationhistory'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.IsSamePatient(arritemsSelected)){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }

        if(element.value === 'Viewmedicationhistory'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.IsSamePatient(arritemsSelected)){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }        

        if(element.value === 'DrugInboxAllergies'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.IsSamePatient(arritemsSelected) ){
            element.ReadOnly = false;
          }else{
           element.ReadOnly = true;
          }          
        }

        if(element.value === 'Druginformation'){
          if(this.items.length > 0 && this.SelectedRecords > 0 && this.IsSameDrugCode(arritemsSelected)){
            element.ReadOnly = false;
          }else{
            element.ReadOnly = true;
          }          
        }
      })

      this.RightMenuList = arr;
      this.UpdateMenu(this.RightMenuList);
    },
  

    UpdateMenu(arr){
      this.OptionsRightMenu.visible = false;
      this.OptionsRightMenu.btnDrugOrdersInboxvisible = true;    
      this.OptionsRightMenu.ItemsList = arr;
      this.OptionsRightMenu.skipLoadLayout = true;
      this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
    },

    

    undoFillOrders() {
      this.$bvModal
        .msgBoxConfirm(this.$t('DrugOrdersInbox.UndoFillOrdersMsg', {'label': this.getSelection().length}), {
          title: this.$t('DrugOrdersInboxRightBar.Undofillorders'),
          okTitle: this.$t('DrugOrdersInbox.TitleUndoFillOrder'),
          cancelTitle: this.$t('Shared.BtnCancel'),
          footerClass: "p-2",
          titleClass: "modal-title modal-type-warning",
        })
        .then((value) => {
          if (value) {
            this.$bvModal
              .msgBoxConfirm(this.$t('DrugOrdersInbox.ConfirmAddNoteMsg'), {
                title: this.$t('DrugOrdersInboxRightBar.Undofillorders'),
                okTitle: this.$t('Shared.TitleYes'),
                cancelTitle: this.$t('Shared.TitleNo'),
                footerClass: "p-2",
                titleClass: "modal-title modal-type-warning",
              })
              .then((value) => {
                if (value) {
                  this.textEditorValue = '';
                  this.textEditorVisible = true;
                } else {
                  this.undoFillOrdersAsync('');
                }
              });
          }
        });
      },

      undoFillOrdersAsync(note) {
        if (this.SignotecEnabled == false || this.SignotecSignatureFile) {

          let params = {
            "recordIds": [],
            "notes": "",
            "signature": this.SignotecSignatureFile
          }
          this.selected = this.getSelection();
          this.selected.forEach(el => {
            params.recordIds.push(el.recordId.trim())
          });

          params.notes = note
          this.setUndoOrders(params)

        } else {
            this.noteUndoFill = note;
            this.SignotecVisible = true;
        }
      },

      setUndoOrders(data) {
        DrugOrdersInboxService.undoOrders(data)
          .then((response) => {
            if(response.status == '200'){                       
              setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              }), 50);
              
              this.getDrugOrdersInbox() 
            }               
          })
          .catch((error) => {
            this.showResponseErrorMessage(error);
          });
      },

      updateChargeable(status) {
        let params = {
          "recordIds": [],
          "chargeable": status === 'CHARGEABLE'
        }
        this.selected = this.getSelection();
        this.selected.forEach(el => {
          params.recordIds.push(el.recordId.trim())
        });

        DrugOrdersInboxService.UpdateChargeable(params)
          .then((response) => {
            if(response.status == '200'){                       
              setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              }), 50);
              
              this.getDrugOrdersInbox() 
            }               
          })
          .catch((error) => {
            this.showResponseErrorMessage(error);
          });
        },

     /* async getMedLabelPdf(){        
      await LetterTemplatesService.getMedLabelPdf('MEDLABEL',this.itemsSelected[0].recordId)
            .then((response) => {      
               if (response.status == '200' && response.data) {
                   this.printData = response.data;
                   this.printPrescription(this.printData.url, this.printData.printerName)      
               }               
         })
         .catch(error => {            
            this.showResponseErrorMessage(error);                
         });    
      }, */

    /* async printPrescription(URL, printerName) {

        let aPrinterName = printerName
        let isPrintExist = true

        let baseurl = this.$store.state.apiurl.replace('/api/', '');
 
        if (qz && qz.log) {
            qz.log.setLevel('silent'); 
        }

        qz.security.setCertificatePromise(function(resolve, reject) {
          ApiService.get('/qztray/certificate')
            .then(function(response) { response.status == '200' ? resolve(response.data) : reject(response.data); });
        });

        qz.security.setSignatureAlgorithm('SHA512');

        qz.security.setSignaturePromise(function(toSign) {
          return function(resolve, reject) {
              ApiService.post("/qztray/sign", { ToSign: JSON.stringify(toSign) })
                .then(function(response) { response.status == '200' ? resolve(response.data.signature) : reject(response.data.signature); });
          };
        });

        if (!qz.websocket.isActive()) {
          try {
              await qz.websocket.connect({
                host: 'localhost',
                usingSecure: true 
              });
              if (!aPrinterName) {
                await qz.printers.getDefault()
                  .then(printerName => {
                      aPrinterName = printerName;
                  })
                  .catch(() => {
                      this.showMessage(this.$t('QZTray.ErrorTitle'),this.$t('QZTray.ErrorDefaultPrinter'),"error");
                  });
              } else {
                await qz.printers.find()
                  .then(printers => {
                      let exist = printers.includes(aPrinterName)
                      if (!exist) {
                        isPrintExist = false
                        this.showMessage(this.$t('QZTray.ErrorTitle'),this.$t('QZTray.PrinterNotExist'),"error");
                      }
                  })
                  .catch (() => {
                      this.showMessage(this.$t('QZTray.ErrorTitle'),this.$t('QZTray.ErrorPrintList'),"error");
                  });
              }
          } catch (err) {
              this.showMessage(this.$t('QZTray.ErrorTitle'),this.$t('QZTray.ErrorMessage'),"error");
          }
        }
        
        const config = qz.configs.create(aPrinterName);

        const data = [{
           type: 'pdf',
           format: 'file',
           data: baseurl + URL
        }];

      if (isPrintExist && qz.websocket.isActive()) {
        await qz.print(config, data);
      }

      if (qz.websocket.isActive()) {
        await qz.websocket.disconnect();
      }
    }*/

    SignotecOnOK() {
        if (!this.SignotecSignatureFile) {
            this.$refs.mdSignotec.confirm();
        }
    },

    SignotecOnCancel() {
        this.SignotecVisible = false;
        this.SignotecSignatureFile = null;
    },

    SignotecOnConfirm() {
        if (this.SignotecSignatureFile) {
            this.SignotecVisible = false;
            this.undoFillOrdersAsync(this.noteUndoFill);
        } else {
            this.showMessage(this.$tc('Msg.Error'),"Please sign","error");
        }
    },

    SignotecOnSubmitImage(data) {
        this.SignotecSignatureFile = data;
    },

    SignotecOnError(msg) {
        this.showMessage(this.$tc('Msg.Error'), msg, "error");
    },

    validate_date_range() {
      return Utils.isDateFromAndDateTo(this.DateFrom, this.DateTo);
    },

    // Método de validación reutilizable
    validateForm() {
      const isValid = this.validate_date_range();
  
      this.isDateFromValid = isValid;
      this.isDateToValid = isValid;
      
      // Forzar actualización del componente
      this.$forceUpdate();
      
      if (!isValid) {
        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
        return false;
      }
      return true;
    },
  },

  async mounted() {  
    this.OptionsRightMenu.visible = false;
    this.OptionsRightMenu.btnDrugOrdersInboxvisible = true;
  // this.OptionsRightMenu.PatientCode = this.$route.params.id;   
    this.OptionsRightMenu.ItemsList = this.RightMenuList;
    this.isFormularyStatusEHRReadOnly = this.$store.state.isDrugInboxFormularyStatusEHRReadOnly;
    this.ModelFormularyStatus =  !this.isFormularyStatusEHRReadOnly ? {code:"Formulary",name:this.$t('DrugOrdersInbox.Formulary')} :{code:"",name:""},

    this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);

    let layoutStatus = this.$store.state.layoutStatus;
    switch(layoutStatus) {
      case 'L0R1':
        this.OptionsRightMenu.favButtonAtion = true;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
      break;
      case 'L1R0':
      case 'L1R1':
          this.OptionsRightMenu.btnvisible = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
      break;
      default:
          this.OptionsRightMenu.favButtonAtion = true;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }

    const allPromise = Promise.all([await this.ExecuteAllCalls()]);
    await allPromise.then(() => {
    }).catch(error => {       
      this.showMessage(this.$tc('Msg.Error'),error,"error");
    });

    this.$emit('onVisibleRightMenu', this.OptionsRightMenu);
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
    sessionStorage.removeItem('DrugOrdersValidationRecordsId');   

    const UserId = LocalStorage.getUserId();
    EmployeeService
      .GetByUserId(UserId)
      .then((response) => {
          if(response.data) {
              let result = response.data;           
              if (result && result.requestSigUndoFillOrders && result.signaturePad == "Signotec") {
                  this.SignotecEnabled = true;
              }
          }
      })
      .catch((error) => {
          this.showResponseErrorMessage(error);
      });
  },

  created() {
    EventBus.$on("DrugOrdersInboxUpdateStatus", function (status) {
      this.setStatusHandler(status);
    }.bind(this));


   

    EventBus.$on("DrugOrdersInboxAllergies", function () {
      this.activateModalAllergies = true;
    }.bind(this));

    EventBus.$on("DrugOrdersModalOutComeMedHistoryDrugOrderInbox", function () {
      this.activateModalMedications = true;
    }.bind(this));

    

    EventBus.$on("DrugOrdersValidation", function () {
      let recordIds = []
        
      this.selected = this.getSelection();
      this.selected.forEach(el => {
        recordIds.push(el.recordId.trim())
      });

      sessionStorage.setItem('DrugOrdersValidationRecordsId', JSON.stringify(recordIds));

      this.$router.push({ name: 'DrugOrdersInboxValidation' });
    }.bind(this));

    //DrugOrdersFill
     EventBus.$on("DrugOrdersSelectAndPush", function (routeName) {
      let recordIds = []; 
      this.selected  = [];     
      this.selected = this.getSelection();      
      this.selected.forEach(el => {
        recordIds.push(el.recordId.trim())
      });
      
      if(this.selected.length > 0){
        sessionStorage.setItem('DrugOrdersValidationRecordsId', JSON.stringify(recordIds));
         this.$router.push({ name: routeName });
      }
     
    }.bind(this));

    EventBus.$on("DrugOrdersExecuteAction", (actionName) => {
      if (actionName === 'AddNotes') {
        this.addingNotes();
      } else if (actionName === 'ReturnedItems') {
        this.returnedItems();
      } else if (actionName === 'UndoFillOrders') {
        this.undoFillOrders();
      }  

    });
    EventBus.$on("DrugOrdersInboxUpdateChargeable", (status) => {
      this.updateChargeable(status);   
    });
    
  },
  
  beforeDestroy() {
    this.RightMenuList = JSON.parse(JSON.stringify(EnumService.DrugOrdersInboxItems)); //JSON.stringify(EnumService.DrugOrdersInboxItems);
   
    EventBus.$off('DrugOrdersInboxUpdateStatus');     
    EventBus.$off('DrugOrdersValidation'); 
    EventBus.$off('DrugOrdersSelectAndPush'); 
    EventBus.$off('DrugOrdersExecuteAction'); 
    EventBus.$off('DrugOrdersModalOutComeMedHistoryDrugOrderInbox');
    EventBus.$off('DrugOrdersInboxUpdateChargeable'); 
  }
};
</script>
<style>
  #fileList{
    padding: 1em;
  }
</style>
